import React, { useEffect, useState } from "react";
import AdminAppBar from "../adminComponents/AdminAppBar";

import LineChart from "../AnalyticsComponent/LineChart";
import StackedBarChart from "../adminComponents/chartComponents/StackBarChart";
import ProgressBar from "./ProgressBar";
import TopPerformer from "./TopPerformer";
import { fetchCallCounts, fetchStageCounts } from '../Services/AnalyticsService'
import { getIcons } from "../Constant/Constant";
import TodayteamActivity from "../BOD/AnalyticsComponent/TodayteamActivity";
import teamService from "../Services/TeamService";
import { showErrorToast } from "../Constant/Notification";
import { set } from "date-fns";

const Analytics = () => {
  const path = "analytics"
  const icons = getIcons();
  const [activeTab, setActiveTab] = useState("overall");
  const [activeTabDay, setActiveTabDay] = useState("Today");

  const [stagesCounts, setStagesCounts] = useState({
    naH0Hq5WlwVjlu66SyoF: 0,
    Q9JZE1p3V8dahjH8eMwl: 0,
    OeC8MZqNykSosVgiPIGx: 0,
    eg6Sa6oxnxCr6ZBz4myj: 0,
    f8ddj5YskQd26cPDcqZM: 0
  });

  const [totalCallCounts, setTotalCallCounts] = useState(0);
  const dealStagesMap = {



    naH0Hq5WlwVjlu66SyoF: {
      icon: icons.totalSiteVisitAnalytics,
      label: "Total Site Visits",
      color: "#B77EAA",
    },
    Q9JZE1p3V8dahjH8eMwl: {
      icon: icons.totalBookingsAnalytics,
      label: "Total Booking",
      color: "#2A76AB",
    },
    OeC8MZqNykSosVgiPIGx: {
      icon: icons.totalFullyRegisteredAnalytics,
      label: "Fully Registered",
      color: "#00A86A",
    },
    eg6Sa6oxnxCr6ZBz4myj: {
      icon: icons.totalDealLostAnalytics,
      label: "Lost Deals Before Booking",
      color: "#E0A0A0",
    },
    f8ddj5YskQd26cPDcqZM: {
      icon: icons.totalDealLostAnalytics,
      label: "Lost Deals After Booking",
      color: "#E0A0A0",
    },
  };

  const [teams, setTeams] = useState([]);

  const [selectedTeam, setSelectedTeam] = useState(teams[0]?.teamId);
// const [mdTeam, setMdTeam] = useState([]);
  const userData = JSON.parse(localStorage.getItem("userData"));
  const userRole = userData?.user?.role;
  const userId = userData?.user?.uid;
let bodTeamData = []
if (userRole === "BOD" || userRole === "MD") {
  bodTeamData =userData?.teamId

}
const [bodTeamId, setBodTeamId] = useState(bodTeamData[0]?.id);




  useEffect(() => {
    if(userRole != "MD" && userRole != "BOD"){
    const fetchTeamsData = async () => {
      try {
        const storedTeams = await teamService.fetchTeams();
        setTeams(storedTeams.data);

        // Set the first team's ID as the selected team if the array is not empty
        if (storedTeams.data.length > 0) {
          setSelectedTeam(storedTeams.data[0].teamId);
        }
      } catch (error) {
        showErrorToast(error.response?.data || "Error fetching teams");
      }
    };
    fetchTeamsData();
  }
  }, []);



  const fetchStageCountsData = async (selectedTeamId) => {
    const newStageCounts = { ...stagesCounts };
    const fetchPromises = [];

    if (userRole) {
      for (const stageId in stagesCounts) {
        if (stageId) {
          fetchPromises.push(
  fetchStageCounts(stageId, selectedTeamId,bodTeamId, userRole, activeTab, userId)
              .then((response) => {
                newStageCounts[stageId] = response.data.stageCount;
              })
              .catch((error) => {
                console.error(`Error fetching data for stage ${stageId}:`, error);
                newStageCounts[stageId] = 0;
              })
          );
        }
      }
    }

    await Promise.all(fetchPromises);
    setStagesCounts(newStageCounts);
  };


  useEffect(() => {
if(userRole === "MD"){
  fetchStageCountsData(bodTeamId);
}else{
    fetchStageCountsData(selectedTeam);
}
  }, [activeTab ]);

  const handleTeamChange = (event) => {
    setSelectedTeam(event.target.value);
    fetchStageCountsData(event.target.value);
  };

  const handleMdTeamChange = (event) => {
    setBodTeamId(event.target.value);

    console.log(event.target.value)
    fetchStageCountsData(event.target.value);
  }

  useEffect(() => {
    const fetchCallCountsData = async () => {
      try {
        const response = await fetchCallCounts(selectedTeam, bodTeamId, userRole, activeTab);
        setTotalCallCounts(response.data.count);
      } catch (error) {
        showErrorToast(error.response?.data || "Error fetching call counts");
      }
    };
    fetchCallCountsData();
  }, [bodTeamId,selectedTeam,activeTab]);
  return (
    <div>
      <AdminAppBar/>
    <div className="   pt-14 bg-appGrayBackground pb-10 ">

      <div className=" 4xl:mx-36 3xl:mx-28 2xl:mx-32 xl:mx-6  custom-xl:mx-24 mt-8  ">
        {/* {userRole === "MD" && ( */}

        <div className="flex items-center  justify-between">
        {/* <div className="bg-white  rounded-md shadow-md h-10 px-3" >
      <div className="flex ">
        {["Today", "Last 7 Days", "Last 28 Days"].map((tab) => (
          <button
            key={tab}
            className={`px-4 py-2 text-sm font-medium ${
              activeTabDay === tab ? "text-custom-dark-green border-b-4 border-custom-dark-green" : "text-gray-500"
            }`}
            onClick={() => setActiveTabDay(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      <div className="p-4 text-gray-700">
        {activeTabDay === "Today" && <p>Showing data for Today.</p>}
        {activeTabDay === "Last 7 Days" && <p>Showing data for the Last 7 Days.</p>}
        {activeTabDay === "Last 28 Days" && <p>Showing data for the Last 28 Days.</p>}
      </div>
    </div> */}

        {userRole === "Admin" || userRole === "CMO" ? (
  <div className={`flex ${activeTab === "team" ? "visible": "invisible"} w-fit gap-10 items-center`}>
    <label htmlFor="teamSelect" className="w-fit text-xl font-medium">
      Team:
    </label>
    <select
      id="teamSelect"
      value={selectedTeam}
      onChange={handleTeamChange}
      className="block w-30 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    >
      {teams.map((team) => (
        <option key={team.id} value={team.teamId}>
          {team.name}
        </option>
      ))}
    </select>
  </div>
) : userRole === "MD" ? (
  <div className={`flex ${activeTab === "team" ? "visible": "invisible"} w-fit gap-10 items-center`}>
    <label htmlFor="teamSelect" className="w-fit text-xl font-medium">
      Team:
    </label>
    <select
      id="teamSelect"
      value={bodTeamId}
      onChange={handleMdTeamChange}
      className="block w-30 py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
    >
      {bodTeamData.map((team) => (
        <option key={team.id} value={team.id}>
          {team.name}
        </option>
      ))}
    </select>
  </div>
) : null}

        {/* )} */}
{userRole !== "BOD"  && (

<div className="relative flex space-x-8 float-right items-center justify-center p-4">
      {/* Toggle Buttons */}
      <button
        className={`text-lg font-normal ${
          activeTab === "overall" ? "text-black text-xl font-semibold" : "text-gray-500"
        }`}
        onClick={() => setActiveTab("overall")}
      >
        Overall Analytics
      </button>
      <button
        className={`text-lg font-normal ${
          activeTab === "team" ? "text-black text-xl font-semibold" : "text-gray-500"
        }`}
        onClick={() => setActiveTab("team")}
      >
        Team Analytics
      </button>

      {/* Animated Underline */}
      <div
        className={`absolute bottom-3 h-1 bg-customGreen rounded transition-all duration-300 ease-in-out`}
        style={{
          width: activeTab === "overall" ? "150px" : "130px", // Adjust width to match text
          transform: activeTab === "overall" ? "translateX(-100px)" : "translateX(75px)", // Adjust position
        }}
      ></div>
    </div>
)}

    </div>

 {/* <div className="flex space-x-8 float-right items-center justify-center p-4">
      <button
        className={`text-lg font-medium ${
          activeTab === "overall" ? "text-black text-xl" : "text-gray-500"
        }`}
        onClick={() => setActiveTab("overall")}
      >
        Overall Analytics
        {activeTab === "overall" && (
          <div className="h-1 bg-customGreen mx-2 rounded mt-1"></div>
        )}
      </button>
      <button
        className={`text-lg font-medium ${
          activeTab === "team" ? "text-black text-xl" : "text-gray-500"
        }`}
        onClick={() => setActiveTab("team")}
      >
        Team Analytics
        {activeTab === "team" && (
          <div className="h-1 bg-customGreen mx-2 rounded mt-1"></div>
        )}
      </button>
    </div> */}
        <div className="  grid grid-cols-6 gap-10  w-full  justify-around  mt-2">

        <div
              className={` bg-[#31859D] w-full h-48 rounded-md flex flex-col justify-center items-center gap-1 text-white`}
            >
              <img className="w-10" src={icons.totalCallAnalytics} alt="" />
              <h1 className="text-2xl font-bold">{totalCallCounts}</h1>
              <h1 className="text-sm">Total Calls</h1>
            </div>
          {Object.keys(dealStagesMap).map((stageId) => (
            <div
              key={stageId}
              style={{ backgroundColor: dealStagesMap[stageId].color }}
              className={`  w-full h-48 rounded-md flex flex-col justify-center items-center gap-1 text-white`}
            >
              <img className="w-10" src={dealStagesMap[stageId].icon} alt="" />
              <h1 className="text-2xl font-bold">{stagesCounts[stageId]}</h1>
              <h1 className="text-sm text-center">{dealStagesMap[stageId].label}</h1>
            </div>
          ))}
        </div>
        <div className=" w-auto mt-6">

{activeTab == "overall" && userRole != "BOD"? (
<StackedBarChart view={path}/>

):(
  <>
  {<TodayteamActivity teamId={selectedTeam} mdTeamId={bodTeamId} />}
  </>

)}

</div>
        </div>

      {/* <div className=" flex 4xl:mx-36 3xl:mx-28 2xl:mx-32 xl:mx-6  custom-xl:mx-24 gap-12 xl:gap-9  custom-xl:gap-10"> */}






      {/* </div> */}


    </div>
    // </div>
  );
};
export default Analytics;